import(/* webpackMode: "eager" */ "F:\\itc\\itcm-ialabs-chatbot-app\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "F:\\itc\\itcm-ialabs-chatbot-app\\src\\app\\context\\ConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "F:\\itc\\itcm-ialabs-chatbot-app\\src\\app\\context\\UserContext.tsx");
;
import(/* webpackMode: "eager" */ "F:\\itc\\itcm-ialabs-chatbot-app\\src\\app\\globals.css");
